import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Layout from '../layout'
const routerPush = VueRouter.prototype.push;
VueRouter.prototype.push = function(location) {
    return routerPush.call(this, location).catch(err => {})
};

Vue.use(VueRouter)

const routes = [{
        path: '/',
        name: 'Layout',
        redirect: '/home',
        component: Layout,
        children: [{
                path: "/home",
                name: 'home',
                component: Home
            }, {
                path: "/standard",
                name: 'standard',
                component: () =>
                    import ( /* webpackChunkName: "Standard" */ '@/views/Standard')
            }, {
                path: "/notice",
                name: 'notice',
                component: () =>
                    import ( /* webpackChunkName: "Notice" */ '@/views/Notice'),

            }, {
                path: "/learning-center",
                component: () =>
                    import ( /* webpackChunkName: "LearningCenter" */ '@/views/LearningCenter')
            }, {
                path: "/personal-center",
                component: () =>
                    import ( /* webpackChunkName: "PersonalCenter" */ '@/views/PersonalCenter')
            }, {
                path: "/app-synopsis",
                component: () =>
                    import ( /* webpackChunkName: "AppSynopsis" */ '@/views/AppSynopsis')
            }, {
                path: "/about",
                component: () =>
                    import ( /* webpackChunkName: "AppSynopsis" */ '@/views/About')
            },
            {
                path: "/teacher-style",
                component: () =>
                    import ( /* webpackChunkName: "TeacherStyle" */ '@/views/TeacherStyle')
            },
            {
                path: "/detail/:name/:title/:id",
                name: 'NoticeDetails',
                component: () =>
                    import ( /* webpackChunkName: "Noticedetails" */ '@/views/Noticedetails')
            },
            {
                path: "/coursedetails",
                component: () =>
                    import ( /* webpackChunkName: "AppSynopsis" */ '@/views/coursedetails')
            },
            {
                path: "/openclass",
                component: () =>
                    import ( /* webpackChunkName: "AppSynopsis" */ '@/views/openclass')
            },
            {
                path: "/search-result",
                name: 'SearchResult',
                component: () =>
                    import ( /* webpackChunkName: "SearchResult" */ '@/views/SearchResult')
            },
            {
                path: "/course-center",
                name: 'CourseCenter',
                component: () =>
                    import ( /* webpackChunkName: "CourseCenter" */ '@/views/CourseCenter')
            },
            {
                path: "/mourse-center",
                name: 'MockCenter',
                component: () =>
                    import ( /* webpackChunkName: "MockCenter" */ '@/views/MockCenter')
            },
            {
                path: "/library",
                name: 'Library',
                component: () =>
                    import ( /* webpackChunkName: "Library" */ '@/views/Library')
            },
            {
                path: "/navtab",
                name: 'Navtab',
                component: () =>
                    import ( /* webpackChunkName: "Library" */ '@/views/navtab')
            },
            {
                path: "/library-details",
                name: 'LibraryDetails',
                component: () =>
                    import ( /* webpackChunkName: "Library" */ '@/views/LibraryDetails')
            },
            {
                path: '/redirect/:path(.*)',
                name: 'redirect',
                component: (resolve) => require(['@/views/redirect'], resolve)
            },
            {
                path: '/topicDetails',
                name: 'topicDetails',
                component: () =>
                    import ('@/views/topicDetails')
            },
            {
                path: '/stureport',
                name: 'stureport',
                component: () =>
                    import ('@/views/stuevaluateAll/stureport')
            },
            {
                path: '/evaluating',
                name: 'evaluating',
                component: () =>
                    import ('@/views/stuevaluateAll/evaluating')
            },
            {
                path: '/earlyWarning',
                name: 'earlyWarning',
                component: () =>
                    import ('@/views/stuevaluateAll/earlyWarning')
            },
            {
                path: '/evaluaDetail',
                name: 'evaluaDetail',
                component: () =>
                    import ('@/views/stuevaluateAll/evaluaDetail')
            },
            {
                path: '/mysetup',
                name: 'mysetup',
                component: () =>
                    import ('@/views/mysetup')
            },
            {
                path: '/mockExamination',
                name: 'mockExamination',
                component: () =>
                    import ('@/views/mockExamination/index')
            },
            {
                path: '/mockdetails',
                name: 'mockdetails',
                component: () =>
                    import ('@/views/mockExamination/details')
            },
            {
                path: '/mypaper',
                name: 'mypaper',
                component: () =>
                    import ('@/views/mockExamination/myPaper')
            },
            {
                path: '/schools-profile',
                name: 'SchoolProfile',
                component: () =>
                    import ('@/views/SchoolProfile.vue')
            },
        ]
    },
    //隐私
    {
        path: "/privacys",
        name: 'privacys',
        component: () =>
            import ('../views/Privacys.vue')
    },
    // {
    //     path: '/login',
    //     name: 'login',
    //     component: () =>
    //         import ('../utils/login/index.vue')
    // },
    // {
    //     path: '/redirect',
    //     component: Layout,
    //     children: [
    //         {
    //         path: '/redirect/:path(.*)',
    //         component: (resolve) => require(['@/views/redirect'], resolve)
    //         }
    //     ]
    // },
]
const router = new VueRouter({
    // mode: 'history', //关闭history 模式
    base: process.env.BASE_URL,
    scrollBehavior(to, from, savedPosition) {
        if (to.path !== '/') {
            return { x: 0, y: 0 }
        }
        // return 期望滚动到哪个的位置
    },
    routes
})

export default router